import { Box, Stack, useTheme } from "@compass/core";
import { AppTopBarBrand } from "./AppTopBarBrand";
import { AppTopBarManual } from "./AppTopBarManual";
import { AppTopBarNavTrigger } from "./AppTopBarNavTrigger";
import { AppTopBarSearch } from "./AppTopBarSearch";
import { AppTopBarUserMenu } from "./AppTopBarUserMenu";
import { useMediaQuery } from "@mui/material";
import { AppTopBarNotifications } from "./AppTopBarNotifications/AppTopBarNotifications";

export const AppTopBar = () => {
  const theme = useTheme();
  const showSearch = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Stack
      direction="row"
      alignItems="center"
      position="relative"
      px={3}
      py={1}
      bgcolor={theme.palette.background.default}
    >
      <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
        <AppTopBarNavTrigger />
        <AppTopBarBrand />
        <AppTopBarManual />
      </Box>

      {showSearch && (
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "100%", maxWidth: 500 }}>
            <AppTopBarSearch />
          </Box>
        </Box>
      )}

      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <AppTopBarNotifications />
        <AppTopBarUserMenu />
      </Box>
    </Stack>
  );
};